import { useSelector } from 'react-redux';

export enum MemberRole {
  MASTER = 4,
  OWNER = 3,
  ADMIN = 2,
  USER = 1,
  GUEST = 0,
}

export const useCommunity = (slug: string) =>
  useSelector(
    (state: any) => state.community.communities[slug || state.community.active]
  );

export const useMember = (): any => {
  const slug = useSelector((state: any) => state.community.active);
  const userMemberships = useSelector((state: any) => state.community.userMemberships);
  return userMemberships.find((m: any) => m.community === slug);
};

export const useRole = (): MemberRole => {
  const isMaster = useSelector((state: any) => state.auth?.user?.role === 'admin');
  const member = useMember();
  switch (true) {
    case isMaster:
      return MemberRole.MASTER;
    case !!member?.superAdmin:
      return MemberRole.OWNER;
    case member?.role === 'admin':
      return MemberRole.ADMIN;
    case member?.role === 'user':
      return MemberRole.USER;
    default:
      return MemberRole.GUEST;
  }
};

export const useRequireRole = (requireRole: MemberRole): boolean => {
  const role = useRole();
  return role >= requireRole;
};
